// extracted by mini-css-extract-plugin
export default {"root":"right-bar-content_root__2bvfm","placeHolderShimmer":"right-bar-content_placeHolderShimmer__f0GMn"};